import React from 'react';
import { useAppState } from '../../contexts/AppStateContext';
import { equalShares } from '../../utils/progress';
import { isDuty } from '../../utils/duties';
import { Avatar } from '../Avatar';
import { EmptyNote } from '../ui/Panel';
import { DutyDots } from '../duties/DutyDots';
export function HouseRotation() {
  const {
    family,
    memberById,
    viewer,
    dutyChecksOf
  } = useAppState();
  const cats = family.templates.filter(t => isDuty(t) && t.planKey !== 'soba');
  if (!family.modules.hisnaOpravila || cats.length === 0) return <EmptyNote data-id="element-162" data-mp="1hgjmohhqzbhr">Hišna opravila niso vklopljena.</EmptyNote>;
  return <div data-id="element-163" data-mp="1lhd9t8nd8m9l">
      <p className="mb-3 text-sm text-muted" data-id="element-164" data-mp="1lgkautunf120">Tedenske zadolžitve · starš pregleda v ponedeljek, sredo in soboto, vrednost se deli med izvajalce.</p>
      <ul className="grid gap-3 sm:grid-cols-2 xl:grid-cols-3" data-id="element-165" data-mp="1qa6i26i1mcqf">
        {cats.map(t => {
        const shares = equalShares(t.baseValue ?? 0, t.assigneeIds);
        const mine = t.assigneeIds.includes(viewer.id);
        return <li key={t.id} className={`flex h-full flex-col rounded-3xl border-[1.5px] p-4 ${mine ? 'border-accent bg-accent-soft/40' : 'border-line bg-surface'}`} data-id="element-166" data-mp="13por0m6j0tnt">
              <span className="flex items-start justify-between gap-2" data-id="element-167" data-mp="u0x2yp4l6ti6">
                <span className="font-display text-lg font-semibold leading-tight" data-id="element-168" data-mp="tyu3lehjno0s">{t.title}</span>
                <span className="shrink-0 rounded-full bg-canvas px-2 py-0.5 text-xs font-extrabold" data-id="element-169" data-mp="ozpwcte6k0d3">{t.baseValue}</span>
              </span>
              <span className="mt-3 flex flex-wrap gap-2" data-id="element-170" data-mp="g0md9pf0jkyl">
                {t.assigneeIds.map(id => {
              const m = memberById(id);
              return m ? <span key={id} className="inline-flex items-center gap-1.5 rounded-full bg-surface py-0.5 pl-0.5 pr-2 text-xs font-bold" data-id="element-171" data-mp="62y783byir14">
                      <Avatar member={m} size="sm" data-id="element-172" data-mp="25er5s4ee84fy" /> {m.name} · {shares[id]}
                    </span> : null;
            })}
              </span>
              <span className="mt-auto pt-3" data-id="element-173" data-mp="3uwo0m202j2oc">
                <DutyDots checks={dutyChecksOf(t.id)} data-id="element-174" data-mp="3uvmlnmfxlw1c" />
              </span>
            </li>;
      })}
      </ul>
    </div>;
}